// Sentry first, so it is set up before anything else runs
import "./sentry"
import * as Sentry from "@sentry/react"
import React from "react"
import ReactDOM from "react-dom/client"
import { ErrorBoundary } from "react-error-boundary"
import "./index.css"
import "./font/MarkPro.ttf"
import reportWebVitals from "./reportWebVitals"
import Application from "./modules/Application"
import { createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles"
import { Provider } from "react-redux"
import store from "./stores/TempStore"
import FallbackRender from "./components/FallbackRender"
import {theme} from "./theme/theme"

console.disableYellowBox = true

window.addEventListener("error", (event) => {
    if (event.message?.includes("Loading chunk") || event.message?.includes("Unexpected token '<'")) {
        console.error("Chunk error detected. Clearing cache and reloading......");
        
        // Prevent infinite reload loop
        if (sessionStorage.getItem("reload_attempted")) return;

        sessionStorage.setItem("reload_attempted", "true");

        // Clear cache
        sessionStorage.clear();
        caches.keys().then((names) => {
            names.forEach((name) => caches.delete(name));
        });

        setTimeout(() => {
            window.location.reload();
        }, 1000);
    }
});

ReactDOM.createRoot(document.getElementById("root")).render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
            {/* Render crashes are caught here, so they are reported to Sentry from here too */}
            <ErrorBoundary fallbackRender={FallbackRender} onError={error => Sentry.captureException(error)}>
                <Provider store={store}>
                    <Application />
                </Provider>
            </ErrorBoundary>
        </ThemeProvider>
    </StyledEngineProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
